module.exports = __webpack_public_path__ + "static/img/google.28232c05.svg";